import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconChevronRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import IconSaveAs from '@/assets/icons/heroIcons/Save-us.svg';
import IconShoppingBag from '@/assets/icons/heroIcons/Shopping-bag.svg';
import IconTariffs from '@/assets/icons/heroIcons/Tariffs.svg';
import { Button } from '@/components/buttons';
import { ContentContainer } from '@/components/layout';
import { SectionHeadline } from '@/components/SectionHeadline';
import { FloatingBox } from '@/components/boxes';
import { LINKS } from '@/constants/links';
import { VideoBox } from '@/components/VideoBox';
import Image from 'next/image';
import IconCheck from '@/assets/icons/heroIcons/Check.svg';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
const ListItem = t0 => {
  const $ = _c(8);
  const {
    id,
    title,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "numbers" : t1;
  let t2;
  if ($[0] !== id || $[1] !== variant) {
    t2 = <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white text-sm leading-4 text-blue-800">{variant === "checkedList" ? <IconCheck className="h-5 w-5" /> : <>{id}</>}</span>;
    $[0] = id;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <span className="text-base">{title}</span>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-row items-start justify-start gap-3">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const Content = t0 => {
  const $ = _c(10);
  const {
    title,
    footer,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="mb-4 text-base lg:mb-8">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="flex flex-col gap-2">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== footer) {
    t3 = <div className="mt-8 flex flex-col items-center gap-3 md:mt-12 lg:flex-row lg:items-start">{footer}</div>;
    $[4] = footer;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
interface ProductsProps {
  onClick: (interest?: string) => void;
}
export const Products = t0 => {
  const $ = _c(78);
  const {
    onClick
  } = t0;
  const {
    t
  } = useTranslation("forEshops");
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bgCircle absolute bottom-24 left-0 hidden h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-90 lg:block lg:h-[35rem] lg:w-[35rem] lg:-translate-x-1/3 lg:-translate-y-1/2" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("products.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <SectionHeadline className="mx-auto mb-12 max-w-[48rem] lg:mb-16" variant="inverted" anchorKey="products.title">{t2}</SectionHeadline>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isCsLanguage || $[6] !== onClick || $[7] !== t) {
    t4 = isCsLanguage && <FloatingBox anchorKey="products.items.1.title" title={<span className="flex flex-row items-center justify-start gap-3 lg:gap-4"><IconDeferredPayment className="h-6 w-6 lg:h-12 lg:w-12" /><span>{t("products.items.1.title")}</span></span>} image={<VideoBox videoUrl="/videos/cs/animation-other.mp4" />} content={<Content title={t("products.items.1.text")} footer={<><Button onClick={() => onClick(t("form.fields.interest.options.1"))} testId="forEshopsIWantIt" analyticsParam="forEshopsIWantIt" variant="primary" size="md" className="h-[58px]">{t("products.items.1.cta.1")}</Button><Button to={LINKS().deferredPayment} testId="forEshopsDeferredPayment" analyticsParam="forEshopsDeferredPayment" variant="secondaryDarkBg" rightIcon={<IconChevronRight />} className="h-[58px] justify-center lg:justify-between">{t("products.items.1.cta.2")}</Button></>}><ListItem id={1} title={t("products.items.1.list.1")} /><ListItem id={2} title={t("products.items.1.list.2")} /><ListItem id={3} title={t("products.items.1.list.3")} /><ListItem id={4} title={t("products.items.1.list.4")} /></Content>} />;
    $[5] = isCsLanguage;
    $[6] = onClick;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconThird className="h-6 w-6 lg:h-12 lg:w-12" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("products.items.2.title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="flex flex-row items-center justify-start gap-3 lg:gap-4">{t5}<span>{t6}</span></span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isCsLanguage || $[15] !== isHuLanguage || $[16] !== t) {
    t8 = isCsLanguage ? <VideoBox videoUrl="/videos/cs/animation-pay-in-three.mp4" /> : <Image alt={t("products.items.1.title")} src={`/images/sections/forEshops/cards/${isHuLanguage ? "hu" : "cs"}/1.png`} width={468} height={468} />;
    $[14] = isCsLanguage;
    $[15] = isHuLanguage;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("products.items.2.text");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onClick || $[21] !== t) {
    t10 = () => onClick(t("form.fields.interest.options.2"));
    $[20] = onClick;
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("products.items.2.cta.1");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <Button onClick={t10} testId="forEshopsIWantIt" analyticsParam="forEshopsIWantIt" variant="primary" size="md" className="h-[58px]">{t11}</Button>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = LINKS();
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = t13.payInThree;
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconChevronRight />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("products.items.2.cta.2");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <Button to={t14} testId="forEshopsPayInThree" analyticsParam="forEshopsPayInThree" variant="secondaryDarkBg" rightIcon={t15} className="h-[58px] justify-center lg:justify-between">{t16}</Button>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t17) {
    t18 = <>{t12}{t17}</>;
    $[34] = t12;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("products.items.2.list.1");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19) {
    t20 = <ListItem id={1} title={t19} />;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t("products.items.2.list.2");
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t21) {
    t22 = <ListItem id={2} title={t21} />;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t("products.items.2.list.3");
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23) {
    t24 = <ListItem id={3} title={t23} />;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = t("products.items.2.list.4");
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t25) {
    t26 = <ListItem id={4} title={t25} />;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t18 || $[54] !== t20 || $[55] !== t22 || $[56] !== t24 || $[57] !== t26 || $[58] !== t9) {
    t27 = <Content title={t9} footer={t18}>{t20}{t22}{t24}{t26}</Content>;
    $[53] = t18;
    $[54] = t20;
    $[55] = t22;
    $[56] = t24;
    $[57] = t26;
    $[58] = t9;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  const t28 = isCsLanguage ? "right" : undefined;
  let t29;
  if ($[60] !== t27 || $[61] !== t28 || $[62] !== t7 || $[63] !== t8) {
    t29 = <FloatingBox anchorKey="products.items.2.title" title={t7} image={t8} content={t27} imagePosition={t28} />;
    $[60] = t27;
    $[61] = t28;
    $[62] = t7;
    $[63] = t8;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== t29 || $[66] !== t4) {
    t30 = <div className="flex flex-col gap-8 md:gap-16">{t4}{t29}</div>;
    $[65] = t29;
    $[66] = t4;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t3 || $[69] !== t30) {
    t31 = <div className="relative overflow-hidden rounded-3xl bg-blue-900 px-4 pt-10 pb-14 text-white md:px-8 md:pb-16 lg:px-12 lg:py-20 2xl:m-auto">{t1}<ContentContainer>{t3}{t30}</ContentContainer></div>;
    $[68] = t3;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== isCsLanguage || $[72] !== onClick || $[73] !== t) {
    t32 = isCsLanguage && <div className="relative mt-14 overflow-hidden rounded-3xl bg-blue-900 px-4 pt-10 pb-14 text-white md:px-8 md:pb-16 lg:mt-20 lg:px-12 lg:py-20"><div className="bgCircle absolute top-0 right-0 hidden h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-180 lg:block lg:h-[25rem] lg:w-[25rem] lg:translate-x-1/2 lg:translate-y-1/3" /><div className="bgCircle absolute bottom-0 left-24 hidden h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-90 lg:block lg:h-[35rem] lg:w-[35rem] lg:-translate-x-1/3 lg:translate-y-1/3" /><ContentContainer><SectionHeadline className="mx-auto mb-12 max-w-[48rem] lg:mb-16" variant="inverted" anchorKey="products.secondTitle">{t("products.secondTitle")}</SectionHeadline><div className="flex flex-col gap-8 md:gap-16"><FloatingBox anchorKey="products.items.3.title" title={<span className="flex flex-row items-center justify-start gap-3 lg:gap-4"><IconShoppingBag className="h-6 w-6 lg:h-12 lg:w-12" /><span>{t("products.items.3.title")}</span></span>} image={<Image src="/images/sections/forEshops/products/cs/css.png" width={468} height={468} alt={t("products.items.3.text")} />} content={<Content title={t("products.items.3.text")} footer={<><Button onClick={() => onClick(t("form.fields.interest.options.4"))} testId="forEshopsIWantIt" analyticsParam="forEshopsIWantIt" variant="primary" size="md" className="h-[58px]">{t("products.items.3.cta.1")}</Button><Button to={LINKS().gcssLandingPage} testId="forEshopsGcss" analyticsParam="forEshopsGcss" variant="secondaryDarkBg" rightIcon={<IconChevronRight />} className="h-[58px] justify-center lg:justify-between">{t("products.items.3.cta.2")}</Button></>}><ListItem id={1} variant="checkedList" title={t("products.items.3.list.1")} /><ListItem id={2} variant="checkedList" title={t("products.items.3.list.2")} /><ListItem id={3} variant="checkedList" title={t("products.items.3.list.3")} /><ListItem id={4} variant="checkedList" title={t("products.items.3.list.4")} /></Content>} /><FloatingBox anchorKey="products.items.4.title" title={<span className="flex flex-row items-center justify-start gap-3 lg:gap-4"><IconTariffs className="h-6 w-6 lg:h-12 lg:w-12" /><span>{t("products.items.4.title")}</span></span>} image={<Image src="/images/sections/forEshops/products/cs/marketingPackages.png" width={468} height={468} alt={t("products.items.4.text")} />} content={<Content title={t("products.items.4.text")} footer={<><Button to="/files/cs/Skippay_Moznosti_propagace_pro-eshopy.pdf" testId="forEshopsIWantIt" analyticsParam="forEshopsIWantIt" variant="secondaryDarkBg" rightIcon={<IconSaveAs />} size="md" className="h-[58px]">{t("products.items.4.cta.1")}</Button><Button onClick={onClick} testId="forEshopsMarketingPackages" analyticsParam="forEshopsMarketingPackages" variant="secondaryDarkBg" rightIcon={<IconChevronRight className="group" />} className="h-[58px] justify-center lg:justify-between">{t("products.items.4.cta.2")}</Button></>}><ListItem id={1} variant="checkedList" title={t("products.items.4.list.1")} /><ListItem id={2} variant="checkedList" title={t("products.items.4.list.2")} /><ListItem id={3} variant="checkedList" title={t("products.items.4.list.3")} /><ListItem id={4} variant="checkedList" title={t("products.items.4.list.4")} /></Content>} imagePosition="right" /></div></ContentContainer></div>;
    $[71] = isCsLanguage;
    $[72] = onClick;
    $[73] = t;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t31 || $[76] !== t32) {
    t33 = <>{t31}{t32}</>;
    $[75] = t31;
    $[76] = t32;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  return t33;
};